import { Auth0Provider } from '@auth0/auth0-react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import RequestsAuth0Bridge from '@client/app/RequestsAuth0Bridge';
import { getAuthorizationParams } from '@client/auth';

let root: ReturnType<typeof createRoot>;

import('react-redux').then(({ Provider }) => {
  import('@client/App').then(({ default: WebApp }) => {
    import('@client/WebAppBeforeLogin').then(({ default: WebAppBeforeLogin }) => {
      import('@client/CallbackPage').then(({ default: CallbackPage }) => {
        import('@client/app/store').then(({ store }) => {
          const container = document.getElementById('root') as HTMLDivElement;
          if (container) {
            root = createRoot(container);
            root.render(
              <Auth0Provider
                domain={import.meta.env.VITE_AUTH0_DOMAIN}
                clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
                useRefreshTokens={true}
                // Refresh tokens are scoped to a single audience. When
                // the app requests a token for a different audience
                // (e.g. cortex-research-api), the refresh token can't
                // fulfill it. Without this fallback the SDK errors out;
                // with it on, the SDK falls back to iframe silent auth
                // and mints the new-audience token using the Auth0
                // session cookie.
                useRefreshTokensFallback={true}
                cacheLocation='localstorage'
                authorizationParams={getAuthorizationParams()}
              >
                <StrictMode>
                  <RequestsAuth0Bridge />
                  <Provider store={store}>
                    {/* Only for enterprise */}
                    <BrowserRouter basename={import.meta.env.VITE_BASE_URL || '/'}>
                      <Routes>
                        <Route path='/callback' element={<CallbackPage />} />
                        <Route
                          path='*'
                          element={
                            <WebAppBeforeLogin>
                              <WebApp />
                            </WebAppBeforeLogin>
                          }
                        />
                      </Routes>
                    </BrowserRouter>
                  </Provider>
                </StrictMode>
              </Auth0Provider>,
            );
          } else {
            throw new Error('No root element found');
          }
        });
      });
    });
  });
});
